import { Component, OnInit } from '@angular/core';
import { IEdificios } from '../interfaces/Edificios';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { IFiltrosConsulta } from '../interfaces/FiltrosConsulta';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IConsultaRegistroVentas } from '../interfaces/ConsultaRegistroVentas';
import Swal from 'sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { IParameters } from '../interfaces/Parametros';
import { PagedResult } from '../interfaces/PagedResult';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-consulta',
  templateUrl: './consulta.component.html',
  styleUrls: ['./consulta.component.css']
})
export class ConsultaComponent implements OnInit {
  edificios: Array<IEdificios>;
  user: UsersData;
  filtros: IFiltrosConsulta;
  formConsulta: FormGroup;
  resultadoConsulta: IConsultaRegistroVentas[];
  submitted = false;
  error:any={isError:false,errorMessage:''};
  term: string = "";
  CategotiasBaresComidas: string[]
  paged!:PagedResult<IConsultaRegistroVentas>
  length !:number
  pageSize = 5
  pageSizeOptions = [5, 10, 25, 100];
  pageIndex = 0

  constructor(private registroServicios: RegistroVentasService,
    private readonly formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private userData: UsersData,
    private msalService: MsalUserService) {
    this.user = userData;
  }

  ngOnInit(): void {
    this.getCategorias()
    this.getEdificiosConsulta(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.construirFromularioConsulta();
    this.formConsulta.controls['term'].valueChanges.subscribe(value => {
      this.term = value;
    });
  }
  construirFromularioConsulta() {
    this.formConsulta = this.formBuilder.group({
      edificio: ['', Validators.required],
      fechaInicio: ['', Validators.required],
      fechaFin: ['', Validators.required],
      term:['']
      
    });
  }

  get f() { return this.formConsulta.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.formConsulta.invalid == false && this.error.isError == true) {
      return;
    }
    else {
      this.ConsultaFiltros();
    }
  }
  clearData(){
    this.resultadoConsulta = []
  }
  filterTerm()
  {
    this.ConsultaFiltros()
  }

  getEdificiosConsulta(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosConsulta(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
       
      }
    );
  }

  ConsultaFiltros() {
    this.spinner.show();
    const filtros: IFiltrosConsulta = {
      Marcas: environment.marcasAutorizadas,
      ...this.formConsulta.value
    };
    filtros.pageSize = this.pageSize
    filtros.pageIndex = this.pageIndex
    filtros.search = this.term
    this.registroServicios.getConsulta(filtros).subscribe(
      resolve => {
        this.paged = resolve
        if (resolve.items.length != 0) {
          this.resultadoConsulta = resolve.items;
          this.length = resolve.totalItems
          this.pageSize = resolve.pageSize;
          this.pageIndex = resolve.pageIndex
        }
        else
        {
          Swal.fire('No se encontraron registros.');
          this.resultadoConsulta = [] ;
        }
        this.spinner.hide();

      },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }


compareTwoDates(){
   if((this.formConsulta.controls['fechaFin'].value)<(this.formConsulta.controls['fechaInicio'].value)){
      this.error={isError:true,errorMessage: 'La fecha fin no debe ser mayor a la fecha inicial'};
   }
   else{
    this.error={isError:false,errorMessage: ''};
   }
}
getCategorias(){
  this.registroServicios.getParametros("INDUSTRY_IMPOCONSUMO").subscribe((response: IParameters) =>{
    this.CategotiasBaresComidas = response.value.split(";")
  })
 }

 changePage(pageEvent:PageEvent){
    this.pageSize = pageEvent.pageSize
    this.pageIndex = pageEvent.pageIndex
    this.ConsultaFiltros()
  }
}
